module.exports = "/static/assets/ff2e5ecc2ff301980e18fb74ac72187c.png";